module.exports = __webpack_public_path__ + "img/live-dash.98013a4d.svg";